module.exports = __webpack_public_path__ + "img/rightsAndInterests.c9bb036f.png";